<script setup lang="ts"></script>
<template>
  <div class="mt-8 rounded-none text-sm flex flex-nowrap text-dimmed">
    <slot></slot>
  </div>
</template>
